import { render } from "./RechargePayPalPage.vue?vue&type=template&id=cbe155cc&ts=true"
import script from "./RechargePayPalPage.vue?vue&type=script&lang=ts"
export * from "./RechargePayPalPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__